<ng-container *ngIf="cseEmploye$ | async as cseEmploye">
    <pre>{{cseEmploye | json}}</pre>
</ng-container>
